export const STORAGE = { session: sessionStorage, local: localStorage };

export const checkDuplicatedReducerConfigs = (configs) => {
  const reducerToConfig = new Set(configs.map(config => config.reducer));
  if (reducerToConfig.size < configs.length) {
    throw new Error(
      'No puedes aplicar dos configuraciones distintas a un mismo reducer. Para ello, crea una configuración con varios filtros.',
    );
  }
};

export const checkRepeatedConditions = (filters) => {
  if (filters) {
    const satisfiedDatas = [];
    let satisfiedDatasLength = 0;

    for (const filter of filters) {
      const { data, condition } = filter;
      if (condition && data && Array.isArray(data)) {
        satisfiedDatas.push(data);
        satisfiedDatasLength += data.length;
      }
    }

    const datasSet = new Set(satisfiedDatas.flat());
    if (datasSet.size < satisfiedDatasLength) {
      throw new Error(
        'Un reducer no puede contener varias condiciones cumplidas para los mismos datos.',
      );
    }
  }
};

export const checkRequiredFields = (element, requiredFields, extraMessage) => {
  for (const field of requiredFields) {
    if (element[field] === undefined) {
      throw new Error(`Es necesario añadir '${field}' ${extraMessage}`);
    }
  }
};

export const executeSecondaryReducersCombinations = (reducers) => {
  Object.keys(reducers).forEach((key) => {
    try {
      if (key !== 'router') {
        reducers[key] = reducers[key]();
      }
    } catch (error) {
      // No imprimir error
    }
  });
};

export const hasTruthyConditions = (projectPersistConfigs) => {
  const { configs } = projectPersistConfigs;
  if (!configs) return false;

  const hasValidConditions = configs.some(config => config.filters.some(filter => filter.condition),);
  return hasValidConditions;
};

export const hasTwoTruthyConditions = (configs) => {
  let count = 0;
  for (const config of configs) {
    if (count === 2) break;
    const { filters } = config;
    for (const filter of filters) {
      const { condition } = filter;
      if (count === 2) break;
      if (condition) count += 1;
    }
  }
  return count > 1;
};

export const placeReducerAtFirstPosition = (configs, reducer) => {
  const reducerConfig = configs.find(config => config.reducer === reducer);
  if (reducerConfig && configs.length > 1) {
    const configsWithoutRoot = configs.filter(
      config => config.reducer !== reducer,
    );
    Object.assign(configs, [reducerConfig, ...configsWithoutRoot]);
  }
};

export const removeDuplicatedDataFromArray = (array) => {
  try {
    if (Array.isArray(array)) {
      return Array.from(new Set(array));
    }
  } catch (error) {
    throw new Error(error);
  }
};
